<template>
  <vc-donut
    background="white" 
    foreground="grey"
    :size="190" unit="px" :thickness="8"
    :sections="sections" :total="100"
  >
  <div v-if="this.graphData[0]=='cu'" class="donut-label mb-2">{{$t("central_units")}}</div>
  <div v-if="this.graphData[0]=='cu_gateways'" class="donut-label mb-2">{{$t("central_units")}} / Gateways</div>
  <div v-if="this.graphData[0]=='gateways'" class="donut-label mb-2">Gateways</div>
  <div v-if="this.graphData[0]=='lamp'" class="donut-label mb-2">{{$t("lamps")}}</div>
  <div v-if="this.graphData[0]=='device'" class="donut-label mb-2">{{$t("devices")}}</div>
  <div v-if="this.graphData[0]=='sensor'" class="donut-label mb-2">{{$t("modules")}}</div>
  <div v-if="this.graphData[0]=='emergency'" class="donut-label mb-2">{{$t("navbar_dispositivi.emergency")}}</div>
  <div v-if="this.graphData[0]=='lighting'" class="donut-label mb-2">{{$t("navbar_dispositivi.lighting")}}</div>
  <div v-if="this.graphData[0]=='bluetooth'" class="donut-label mb-2"><i class="fa fa-bluetooth-b mr-2"></i>{{$t("bluetooth.devices")}}</div>
  <div class="donut-value">{{this.totalDevice}}</div>
  </vc-donut>
</template>

<script>
import Vue from 'vue';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
Vue.use(Donut);

  export default {
    name: 'GraficoDonut',
    props: {
      graphData: Array
    },
    mounted() {
        this.totalDevice=this.graphData[1];
        var deviceOk=this.graphData[2];
        var deviceFail=this.graphData[3];
        var deviceDisc=this.graphData[4];
        var deviceManualBle=this.graphData[5];
        var deviceOrphan = this.graphData[6];
        //si usa totalData invece di totalDevice perché gli erroi potrebbero essere in numero maggiore ai dispositivi (qualcuno può avere più errori...)
        var totalData = deviceOk + deviceFail + deviceDisc + deviceManualBle + deviceOrphan;
        console.log("Donut ", this.graphData[0], ": totale", this.totalDevice, " Ok", deviceOk, " Fail", deviceFail, " Disc", deviceDisc, " ManualBle", deviceManualBle, " Orphan", deviceOrphan);
        if (totalData != 0) { //se non ci sono dispositi non faccio null perché farei divisioni per 0
          this.sections=[];
          var deviceOk_p={value:(deviceOk/totalData)*100, color:"#29CC96"};
          var deviceFail_p={value:(deviceFail/totalData)*100, color:"#F03040"};
          var deviceDisc_p = { value: (deviceDisc / totalData) * 100, color: "#E3E6E7" };
          var deviceManualBle_p = {value:(deviceManualBle/totalData)*100, color:"#04709C"};
          var deviceOrphan_p={value:(deviceOrphan/totalData)*100, color:"#EE82EE"};
          this.sections.push(deviceOk_p);
          this.sections.push(deviceFail_p);
          this.sections.push(deviceDisc_p);
          this.sections.push(deviceManualBle_p);
          this.sections.push(deviceOrphan_p);
        }
    },
    data() {
      return {
          sections: [],
          totalDevice:0
      };
    }
  };
</script>
